// 主路由表
export default [
  {
    path: '/',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '华贸通-统一登录',
    },
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '华贸通-统一登录',
    },
  },
  {
    path: '/services',
    component: () => import('@/views/services/services.vue'),
    meta: {
      title: '华贸通-服务列表',
    },
  },
  {
    path: '/wx/qw-login',
    component: () => import('@/views/wx/index.vue'),
    meta: {
      title: '企业微信重定向页面',
    },
  },
]
